import React, { useEffect, useState } from "react";
import { CFormLabel, CCol, CForm, CFormInput, CFormSelect } from '@coreui/react'
import { useAuth } from "../../contexts/authContext";
import { collection, doc, getDoc, getDocs, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore";
import db, { auth } from "../../firebase/firebaseConfig";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLoading } from "../Loading";
import { toZonedTime } from 'date-fns-tz';
import { updateProfile } from "firebase/auth";

function ApplicationForm() {
    const malaysiaStates = [
        "Johor",
        "Kedah",
        "Kelantan",
        "Malacca",
        "Negeri Sembilan",
        "Pahang",
        "Perak",
        "Perlis",
        "Penang",
        "Sabah",
        "Sarawak",
        "Selangor",
        "Terengganu",
        "Kuala Lumpur",
    ];
    const{setLoading} = useLoading();
    const location = useLocation();
    const origin = location?.state?.root || false;
    const { id } = useParams();
    const { currentUser } = useAuth();
    const [shelterId, setShelterId] = useState();
    const petId = id;
    const navigate = useNavigate();

    useEffect(() => {
        if (!origin) {
            navigate('/');
        }
    })

    useEffect(() => {
        if (!currentUser.uid) {
            navigate('/login');
        }

        const fetchInfo = async () => {
            const adopterCollection = doc(db, "Adopters", currentUser.uid);
            const adopterSnapshot = await getDoc(adopterCollection);
            if (adopterSnapshot.exists()) {
                const adopterData = { ...adopterSnapshot.data() };
                setApplicationData(adopterData);
            }
            const shelterrCollection = doc(db, "Pets", petId);
            const shelterSnapshot = await getDoc(shelterrCollection);
            if (shelterSnapshot.exists()) {
                const shelterData =  shelterSnapshot.data().shelterId ;
                setShelterId(shelterData);
                setLoading(false);
            }
        };
        fetchInfo();
    }, [currentUser, navigate]);

    const [applicationData, setApplicationData] = useState({
        name: "",
        icNumber: "",
        age: "",
        address: "",
        city: "",
        state: "",
        postcode: "",
        email: "",
        phoneNumber: "",
        gender: "",
        whoAdoptfor: "",
        noOfAdults: "",
        hadPet: "",
        hadSurrendered: "",
        surrenderedReason: "",
        typeOfHome: "",
        petAllergic: "",
        mainCaregiver: "",
        emailofCaregiver: "",
        noOfOtherPets: "",
    });

    const [additionalData, setAdditionalData] = useState({
        whoAdoptfor: "",
        noOfAdults: "",
        hadPet: "",
        hadSurrendered: "",
        surrenderedReason: "",
        typeOfHome: "",
        petAllergic: "",
        mainCaregiver: "",
        emailofCaregiver: "",
        noOfOtherPets: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if ((/^\d{6}-\d{2}-\d{4}$/.test(applicationData.icNumber)) && applicationData?.postcode?.length === 5
            && applicationData.age >= 12 && applicationData.age <= 100 && (/^\+601\d-\d{7,8}$/.test(applicationData.phoneNumber))) {

            if (
                (additionalData.hadPet === "Yes" && !additionalData.noOfOtherPets) ||
                (additionalData.hadSurrendered === "Yes" && !additionalData.surrenderedReason)
            ) {
                return;
            }
            else {
                setLoading(true);
                // const applicationRef = doc(db, "Applications", `${currentUser.uid}_${petId}`);
                // const applicationSnap = await getDoc(applicationRef);

                // let applicationName = `${currentUser.uid}_${petId}`;
                // if (applicationSnap.exists() && (applicationSnap.data().status === "Cancel" || applicationSnap.data().status === "Rejected")) {
                //     applicationName = `${currentUser.uid}_${petId}_${Date.now()}`;
                // }

                const applicationRef = query(
                    collection(db, "Applications"),
                    where("adopterId", "==", currentUser.uid),
                    where("petId", "==", petId)
                );
                const applicationSnap = await getDocs(applicationRef);
                let applicationName; // To store the application document reference
            
                if (applicationSnap.empty) {
                    // No existing application, create a new one
                    applicationName = `${currentUser.uid}_${petId}`;
                } else {
                    let foundRepeat = false;
                    // Existing application(s) found
                    const promises = applicationSnap.docs.map(async(docSnap) => {
                        const applicationData = docSnap.data();
                        if (applicationData.status === "Pending") {
                            alert("You have a pending or approved application for this pet.");
                            setLoading(false);
                            navigate(`/application-status/${docSnap.id}`, { replace: true });
                            window.history.pushState(null, "", window.location.href);
                            window.onpopstate = function () {
                                window.history.pushState(null, "", window.location.href);
                            };
                            foundRepeat =true;
                            return; // Exit the loop
                        }
                        else if(applicationData.status === "Approved")
                        {
                            const appointmentRef = doc(db, "Appointments", docSnap.id);
                            const appointmentSnap = await getDoc(appointmentRef);
                            if (appointmentSnap.exists() && appointmentSnap.data().status !== "Rejected") {
                                alert("You have a pending or approved application for this pet.");
                                setLoading(false);
                                navigate(`/application-status/${docSnap.id}`, { replace: true });
                                window.history.pushState(null, "", window.location.href);
                                window.onpopstate = function () {
                                    window.history.pushState(null, "", window.location.href);
                                };
                                foundRepeat =true;
                                return; // Exit the loop
                            }
                            else if (!appointmentSnap.exists() ) {
                                alert("You have a pending or approved application for this pet.");
                                setLoading(false);
                                navigate(`/application-status/${docSnap.id}`, { replace: true });
                                window.history.pushState(null, "", window.location.href);
                                window.onpopstate = function () {
                                    window.history.pushState(null, "", window.location.href);
                                };
                                foundRepeat =true;
                                return; // Exit the loop
                            }
                            else{
                                applicationName = `${currentUser.uid}_${petId}_${Date.now()}`;
                            }
                        }
                        else{
                            applicationName = `${currentUser.uid}_${petId}_${Date.now()}`;
                        }
                    });
                    await Promise.all(promises);
                    if(foundRepeat)
                    {
                        return;
                    }
                }


                const zonedDate = toZonedTime(new Date(), 'Asia/Kuala_Lumpur');
                const firebaseTimestamp = Timestamp.fromDate(zonedDate);
                const combinedData = {
                    ...applicationData,
                    ...additionalData,
                    petId: petId,
                    adopterId: currentUser.uid,
                    shelterId: shelterId,
                    status: "Pending",
                    timestamp: firebaseTimestamp,
                };
                try {
                    const applicationRef = doc(db, "Applications", applicationName);
                    await setDoc(applicationRef, combinedData);

                    const user = auth.currentUser;
                    await updateProfile(user, {
                        displayName: applicationData.name,
                    });

                    const adopterRef = doc(db, "Adopters", currentUser.uid);
                    await updateDoc(adopterRef, applicationData);
                    alert("Application submitted successfully!");
                    setLoading(false);
                    navigate(`/application-status/${applicationName}`, { replace: true });

                    // Prevent back navigation
                    window.history.pushState(null, "", window.location.href);
                    window.onpopstate = function () {
                        window.history.pushState(null, "", window.location.href);
                    };

                } catch (error) {
                    console.error("Error submitting form:", error);
                    setLoading(false);
                }
            }
        }
    }

    return (
        <>
            <div className="applicationFormContainer">
                <h1>Adoption Form</h1>
                <div className="personalContainer">
                    <h2>Personal Information</h2>
                    <CForm className="row g-3" onSubmit={handleSubmit}>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputName" className="formLabel">Name</CFormLabel>
                            <CFormInput id="inputName" value={applicationData.name} required
                                onChange={(e) => setApplicationData({ ...applicationData, name: e.target.value })} />
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel htmlFor="inputIC" className="formLabel">IC Number</CFormLabel>
                            <CFormInput id="inputIC" value={applicationData.icNumber} required
                                onChange={(e) => { setApplicationData(prev => ({ ...prev, icNumber: e.target.value })); }}
                            />
                            {applicationData.icNumber && !(/^\d{6}-\d{2}-\d{4}$/.test(applicationData.icNumber)) && (
                                <p className="errorMessage">IC Number must be in the format xxxxxx-xx-xxxx</p>
                            )}
                        </CCol>
                        <CCol md={2}>
                            <CFormLabel htmlFor="inputAge" className="formLabel">Age</CFormLabel>
                            <CFormInput id="inputAge" type="number" value={applicationData.age} required min="12" max="100"
                                onChange={(e) => setApplicationData({ ...applicationData, age: e.target.value.replace(/\D/g, "") })} />
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputEmail" className="formLabel">Email</CFormLabel>
                            <CFormInput type="email" id="inputEmail" value={applicationData.email}  disabled readOnly/>
                        </CCol>
                        <CCol md={2}>
                            <CFormLabel htmlFor="inputGender" className="formLabel">Gender</CFormLabel>
                            <CFormSelect id="inputGender" value={applicationData.gender} required
                                onChange={(e) => setApplicationData({ ...applicationData, gender: e.target.value })}>
                                <option value="Female">Female</option>
                                <option value="Male">Male</option>
                            </CFormSelect>
                        </CCol>
                        <CCol md={4}>
                            <CFormLabel htmlFor="inputTelephone" className="formLabel">Telephone</CFormLabel>
                            <CFormInput id="inputTelephone" value={applicationData.phoneNumber} required
                                onChange={(e) => { setApplicationData(prev => ({ ...prev, phoneNumber: e.target.value })); }}
                            />
                            {applicationData.phoneNumber && !(/^\+601\d-\d{7,8}$/.test(applicationData.phoneNumber)) && (
                                <p className="errorMessage">Phone Number must be in the format +601x-xxxxxxx</p>
                            )}
                        </CCol>

                        <CCol xs={12}>
                            <CFormLabel htmlFor="inputAddress" className="formLabel">Address</CFormLabel>
                            <CFormInput id="inputAddress" value={applicationData.address} required
                                onChange={(e) => setApplicationData({ ...applicationData, address: e.target.value })} />
                        </CCol>

                        <CCol md={3}>
                            <CFormLabel htmlFor="inputPostcode" className="formLabel">Postcode</CFormLabel>
                            <CFormInput id="inputPostcode" value={applicationData.postcode} required
                                maxLength={5}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                                    if (/^\d{0,5}$/.test(value)) {
                                        setApplicationData(prev => ({ ...prev, postcode: value }));
                                    }
                                }}
                            />
                            {applicationData?.postcode?.length < 5 && applicationData?.postcode.length > 0 && (
                                <p className="errorMessage">Postcode must be exactly 5 digits</p>
                            )}
                        </CCol>

                        <CCol md={3}>
                            <CFormLabel htmlFor="inputCity" className="formLabel">City</CFormLabel>
                            <CFormInput id="inputCity" value={applicationData.city} required
                                onChange={(e) => setApplicationData({ ...applicationData, city: e.target.value })} />
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputState" className="formLabel">State</CFormLabel>
                            <CFormSelect id="inputState" value={applicationData.state} required
                                onChange={(e) => setApplicationData({ ...applicationData, state: e.target.value })}>
                                {malaysiaStates.map(state => (
                                    <option key={state} value={state}>{state}</option>
                                ))}
                            </CFormSelect>
                        </CCol>

                        <CCol md={12}>
                            <h2 className="additionalheader">Addtional Information</h2>
                        </CCol>

                        <CCol md={6}>
                            <CFormLabel htmlFor="inputWho" className="formLabel">Who are you adopting for</CFormLabel>
                            <CFormInput id="inputWho" value={additionalData.whoAdoptfor} required
                                onChange={(e) => setAdditionalData({ ...additionalData, whoAdoptfor: e.target.value })} />
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputAdult" className="formLabel">Number of adults at home</CFormLabel>
                            <CFormInput id="inputAdult" value={additionalData.noOfAdults} required
                                onChange={(e) => setAdditionalData({ ...additionalData, noOfAdults: e.target.value.replace(/\D/g, "") })} />
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputHadPet" className="formLabel">Do you had pet before</CFormLabel>
                            <CFormSelect id="inputHadPet" value={additionalData.hadPet} required
                                onChange={(e) => setAdditionalData({ ...additionalData, hadPet: e.target.value })}>
                                <option value="">Choose...</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </CFormSelect>
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputNoOfPet" className="formLabel">If yes, how many pets do you have now</CFormLabel>
                            <CFormInput id="inputNoOfPet" value={additionalData.noOfOtherPets} disabled={additionalData.hadPet !== "Yes"}
                                onChange={(e) => setAdditionalData({ ...additionalData, noOfOtherPets: e.target.value.replace(/\D/g, "") })} />
                            {additionalData.hadPet === "Yes" && !additionalData.noOfOtherPets && (
                                <p className="errorMessage">Number of your current pets is required if you selected "Yes".</p>
                            )}
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputHadSurrendered" className="formLabel">Have you ever surrendered pet</CFormLabel>
                            <CFormSelect id="inputHadSurrendered" value={additionalData.hadSurrendered} required
                                onChange={(e) => setAdditionalData({ ...additionalData, hadSurrendered: e.target.value })}>
                                <option value="">Choose...</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </CFormSelect>
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputSurrenderedReason" className="formLabel">If yes, please provide the reason</CFormLabel>
                            <CFormInput id="inputSurrenderedReason" value={additionalData.surrenderedReason} disabled={additionalData.hadSurrendered !== "Yes"}
                                onChange={(e) => setAdditionalData({ ...additionalData, surrenderedReason: e.target.value })} />
                            {additionalData.hadSurrendered === "Yes" && !additionalData.surrenderedReason && (
                                <p className="errorMessage">Reason is required if you selected "Yes".</p>
                            )}
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputHomeType" className="formLabel">What type of home do you live in</CFormLabel>
                            <CFormSelect id="inputHomeType" value={additionalData.typeOfHome} required
                                onChange={(e) => setAdditionalData({ ...additionalData, typeOfHome: e.target.value })}>
                                <option value="">Choose...</option>
                                <option value="Landed Property">Landed Property</option>
                                <option value="High-rise Building">High-rise Building</option>
                            </CFormSelect>
                        </CCol>
                        <CCol md={6}>
                            <CFormLabel htmlFor="inputPetAllergic" className="formLabel">Is anybody in the household allergic to animals</CFormLabel>
                            <CFormSelect id="inputPetAllergic" value={additionalData.petAllergic} required
                                onChange={(e) => setAdditionalData({ ...additionalData, petAllergic: e.target.value })} >
                                <option value="">Choose...</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </CFormSelect>
                        </CCol>

                        <CCol md={6}>
                            <CFormLabel htmlFor="inputCaregiver" className="formLabel">Who will be the main caregiver for this pet</CFormLabel>
                            <CFormInput id="inputCaregiver" value={additionalData.mainCaregiver} required
                                onChange={(e) => setAdditionalData({ ...additionalData, mainCaregiver: e.target.value })} />
                        </CCol>

                        <CCol md={6}>
                            <CFormLabel htmlFor="inputCaregiverEmail" className="formLabel">Caregiver Email</CFormLabel>
                            <CFormInput id="inputCaregiverEmail" type="email" value={additionalData.emailofCaregiver} required
                                onChange={(e) => setAdditionalData({ ...additionalData, emailofCaregiver: e.target.value })} />
                        </CCol>

                        <CCol xs={12}>
                            <button type="submit" className="submitBtn" >Submit</button>
                        </CCol>
                    </CForm>

                </div>

            </div>

        </>
    );
}

export default ApplicationForm;
